export default __webpack_public_path__ + "static/feature-importances-long--mobile-1afed70674149b32ce7fb5a33c7d6eff.png";